import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHomeLargeComponent } from "./med-icon-home-large.component";

@NgModule({
  declarations: [
    MedIconHomeLargeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHomeLargeComponent,
  ],
})
export class MedIconHomeLargeModule { }
